import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroBenefitRows, heroMockupUrl } from '../data/hero';
import { trustLine } from '../data/offer';
export function Hero() {
  return <>
      <section className="w-full bg-mist px-4 py-2 text-navy sm:py-4 lg:py-6" data-id="element-104" data-mp="9ll6ipqopkjt">
        <div className="mx-auto max-w-5xl text-center" data-id="element-105" data-mp="4mru70n4vzl8">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber sm:text-[11px]" data-id="element-106" data-mp="4jvyzk2o7p0h">
            Guarigione Familiare Sistemica
          </motion.span>
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.08
        }} data-id="element-107" data-mp="3d21uq4bdkwqw">
            <h1 className="mx-auto mt-2 max-w-xl text-2xl italic leading-tight text-amber sm:mt-3 sm:max-w-2xl sm:text-[2rem] lg:text-[2.5rem]" style={{
            fontWeight: '700',
            fontFamily: "'Noto Sans', sans-serif"
          }} data-id="element-108" data-mp="3j898df6ywfql">
              Scopri gli schemi invisibili della tua storia familiare.
            </h1>
            <p className="mx-auto mt-2 max-w-2xl text-[13px] leading-snug text-slate sm:mt-3 sm:text-base sm:leading-relaxed" data-id="element-109" data-mp="3e7l8e40rgok8">
              Strumenti pronti all’uso per comprendere i tuoi schemi familiari, liberare le eredità del passato e
              scrivere una nuova storia...
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.16
        }} className="mx-auto mt-3 max-w-3xl text-center sm:mt-5" data-id="element-110" data-mp="2viy1dfz0xp40">
            <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-amber sm:text-xs" data-id="element-111" data-mp="2ljz2gp4297u7">
              📦 Tutto ciò che ricevi istantaneamente
            </p>
            <div className="mt-1.5 space-y-0.5 text-[10px] font-medium leading-snug text-slate sm:mt-3 sm:space-y-1 sm:text-xs lg:text-sm" data-id="element-112" data-mp="na9zingu3cke">
              {heroBenefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 sm:gap-x-6 sm:gap-y-1" data-id="element-113" data-mp="ddwy13f1ruf3">
                  {row.map(benefit => <span key={benefit} className="whitespace-nowrap" data-id="element-114" data-mp="162ccnou9oapw">
                      {benefit}
                    </span>)}
                </p>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.24
        }} className="mx-auto mt-3 max-w-3xl sm:mt-5" data-id="element-115" data-mp="x3h260k6wegs">
            <img src={heroMockupUrl} alt="Il Sistema delle Costellazioni Familiari™ : la collezione completa, i 6 tomi, gli strumenti di genogramma e le guide di esercizi" className="mx-auto block h-auto w-full max-w-lg rounded-3xl object-contain shadow-elevated sm:max-w-xl lg:max-w-2xl" data-id="element-116" data-mp="1xam5wruslszg" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.3
        }} className="mt-3 sm:mt-5" data-id="element-117" data-mp="2g0c0peyk2erd">
            <CTAButton href="#collezione-completa" pulse size="large" data-id="element-118" data-mp="2p10fwczoql5u">
              ⚡ ACCESSO ISTANTANEO
            </CTAButton>
            <p className="mx-auto mt-2 max-w-3xl text-[11px] leading-relaxed text-slate sm:mt-3 sm:text-sm" data-id="element-119" data-mp="2tx7okdjguarh">
              📄 PDF Altissima Qualità <span className="mx-1" data-id="element-120" data-mp="zl12gjp1a9ke">·</span> 🖨️ Risorse Stampabili <span className="mx-1" data-id="element-121" data-mp="znn82dsd6ezz">·</span>{' '}
              {trustLine}
            </p>
          </motion.div>
        </div>
      </section>
      <section className="border-y border-amber/40 bg-surface px-4 py-5 text-navy" data-id="element-122" data-mp="3vi6yekswiato">
        <div className="mx-auto max-w-3xl text-center" data-id="element-123" data-mp="e9a7y7n4v4mq">
          <p className="text-sm font-bold uppercase tracking-[0.12em] sm:text-base" data-id="element-124" data-mp="e8sefiruv4ii">🚀 Offerta di lancio attiva</p>
          <span aria-hidden="true" className="mx-auto mt-3 block h-px w-24 bg-amber/60" data-id="element-125" data-mp="98e23oj818eo" />
          <p className="mt-3 text-xs font-medium text-slate sm:text-sm" data-id="element-126" data-mp="3hqk06ffees89">
            5 Bonus Premium inclusi gratuitamente per un periodo limitato.
          </p>
        </div>
      </section>
    </>;
}